import React from "react"

import {
	Box,
	Grid,
} from "@mui/material"

import { Loading } from "@sinossi/mates-react-library"

import { t } from "@lingui/macro"

import {
	PageHeader,
	PageSectionTitle,
	RoutesData,
} from "components/commons"
import withUseRouter, { UseRouterParams } from "services/router"
import {
	MatesComponent,
	MatesComponentState,
} from "components/mates-component"

import {
	SupportCard,
	SupportCardData,
	SupportForm,
	TicketsTable,
} from "components/supportAndDocumentation"

interface SupportAndDocumentationProps extends UseRouterParams
{
}
interface SupportAndDocumentationState extends MatesComponentState
{
	loading: boolean
	activeSection: string|null
}

const mockTickets = {
	items: [
		{
			id: "0",
			updates: false,
			date: "10/12/2022",
			status: "in progress",
			ticketNumber: "703636700",
		},
		{
			id: "1",
			updates: true,
			date: "28/02/2023",
			status: "chiuso",
			ticketNumber: "168970715",
		},
		{
			id: "2",
			updates: true,
			date: "30/04/2023",
			status: "in progress",
			ticketNumber: "289185230",
		},
		{
			id: "3",
			updates: false,
			date: "01/07/2023",
			status: "in progress",
			ticketNumber: "390226753",
		},
		{
			id: "4",
			updates: true,
			date: "20/10/2023",
			status: "chiuso",
			ticketNumber: "119220750",
		},
	],
	pagination:{
		currentPage: 0,
		totalRecords: 25
	}
}

class SupportAndDocumentation extends React.Component<SupportAndDocumentationProps, SupportAndDocumentationState>
{
	private readonly matesComponent: MatesComponent<SupportAndDocumentationProps,SupportAndDocumentationState > = new MatesComponent(this)

	constructor(props: any)
	{
		super(props)
		this.state = {
			...this.matesComponent.setupState(),
			loading: false,
			activeSection: "supportAndDocumentation",
		}
	}

	render()
	{
		return (
			<Box sx={{ width: '100%', pt: 2, position: "relative" }}>
				<Loading show={this.state.loading} />
				<PageHeader
					title={RoutesData.SUPPORT_AND_DOCUMENTATION.title}
					paths={[ RoutesData.DASHBOARD, RoutesData.SUPPORT_AND_DOCUMENTATION ]}
				/>

				<Grid container spacing={1}>
					<Grid item xs={6} md={6}>
						<SupportCard
							type={SupportCardData.GUIDE}
							title={"GUIDA UTENTE"}
							text={"Scopri come utilizzare al meglio le funzioni della piattaforma"}
						/>
						<PageSectionTitle title={t({ id: "support-open-tickets", message: "Ticket aperti" })} />
						<Box maxWidth="100%" height="80vh" sx={{ bgcolor: 'background.default', pt: 2, px: 2}}>
							<TicketsTable data={mockTickets} handleCallback={() => {}}/>
						</Box>
					</Grid>
					<Grid item xs={6} md={6}>
						<SupportCard
							type={SupportCardData.FAQ}
							title={"FAQ"}
							text={"Consulta le domande più frequenti poste dagli altri utenti"}
						/>
						<PageSectionTitle title={t({ id: "support-contact-support", message: "Contatta il supporto tecnico" })} />
						<Box maxWidth="100%" height="80vh" sx={{ bgcolor: 'background.default', pt: 2, px: 2}}>
							<SupportForm />
						</Box>
					</Grid>
				</Grid>

			</Box >
		)
	}
}

export default withUseRouter(SupportAndDocumentation)
